import { GridBoxList } from '@factorialco/deprecated-design-system'
import { PermissionsPermissionsDocument } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useQuery } from 'modules/core/hooks/useQuery'

import {
  PERMISSION_GROUP_KIND_ADMIN,
  PERMISSION_GROUP_KIND_CUSTOM,
  PERMISSION_GROUP_KIND_DEFAULT,
  PERMISSION_GROUP_KIND_ONBOARDING,
} from 'modules/permissions/lib/constants'
import permissionGroups from 'modules/permissions/store/collections/permissionGroups'

import Item from './Item'

const PERMISSION_GROUP_SORT_ORDER = [
  PERMISSION_GROUP_KIND_ADMIN,
  PERMISSION_GROUP_KIND_DEFAULT,
  PERMISSION_GROUP_KIND_ONBOARDING,
  PERMISSION_GROUP_KIND_CUSTOM,
]

const PermissionGroups = () => {
  const { data } = useQuery(PermissionsPermissionsDocument, {})

  const permissionGroupsModels = permissionGroups.models

  return (
    <GridBoxList centered={permissionGroupsModels.length < 2}>
      {[...permissionGroupsModels]
        .sort((a, b) => {
          return (
            PERMISSION_GROUP_SORT_ORDER.indexOf(a.attributes.kind) -
            PERMISSION_GROUP_SORT_ORDER.indexOf(b.attributes.kind)
          )
        })
        .map((permissionGroup) => (
          <Item
            key={permissionGroup.attributes.id}
            permissionGroup={permissionGroup}
            canDuplicate={data?.permissions._policies.groupDuplicate.can || false}
            canApplyRoleTemplates={data?.permissions._policies.roleTemplateApply.can || false}
          />
        ))}
    </GridBoxList>
  )
}

export default observer(PermissionGroups)
